<script>
    import { createEventDispatcher } from "svelte";
    import { sto_cliente_web, usucon } from "../../store";
    const dispatch = createEventDispatcher();

    export let token;
    let url = `${$sto_cliente_web.redirect_url}?code=${token}&state=${$sto_cliente_web.state}`;
</script>

<div class="w3-content" style="max-width: 450px">
    <div class="w3-padding">
        <h1 style="font-size:xx-large; font-weight: bolder;">
            <div>Consentimiento</div>
        </h1>
        <div class="w3-section w3-large w3-padding-24 w3-round w3-light-grey">
            <div class="w3-text-red w3-center w3-padding">
                Por medio de la presente, confirmamos tu identidad a <b>Universia.com</b>.
            </div>
        </div>
        <div class="w3-display-container" style="height: 30px;">
            <a
                href={url}
                on:click={() => dispatch("conceder")}
                class="w3-display-left w3-btn w3-blue w3-text-white w3-round w3-round"
                >Continuar
            </a>

           <!--  <button
                on:click={() => dispatch("noconceder")}
                class="w3-display-right w3-btn w3-red w3-text-white w3-round w3-round"
                >No</button
            > -->
        </div>
    </div>
</div>
